module.exports = __webpack_public_path__ + "img/ReviewIcon.b9400724.png";